import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles/index.css";

const container = document.getElementById("root");
if (!container) throw new Error("The app has no mount point.");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
